module.exports = __webpack_public_path__ + "a2edb740fae98d1cf037b8568d90cbd5.png";